module.exports = __webpack_public_path__ + "static/media/c++.8cc47c68.svg";